import Phaser from 'phaser';

export class ContextMenu extends Phaser.GameObjects.Container {
    constructor(scene, x, y, options = []) {
        super(scene, x, y);
        

        
        this.scene = scene;
        this.options = options;
        this.background = null;
        this.optionButtons = [];
        this.isVisible = false;
        
        this.createMenu();
        this.setDepth(1000); // Ensure menu appears above everything
        this.setVisible(false);
        
        // Add to scene
        scene.add.existing(this);
    }
    
    createMenu() {
        // Calculate menu width based on text content
        let maxTextWidth = 120; // Minimum width
        
        // Measure text width for each option
        this.options.forEach(option => {
            const tempText = this.scene.add.text(0, 0, option.text, {
                fontSize: '12px',
                fill: '#ffffff'
            });
            maxTextWidth = Math.max(maxTextWidth, tempText.width + 20); // Add padding
            tempText.destroy(); // Clean up temporary text
        });
        
        const menuWidth = maxTextWidth;
        const menuHeight = this.options.length * 24 + 8;
        
        // Store dimensions for later use
        this.menuWidth = menuWidth;
        this.menuHeight = menuHeight;
        
        // Create background
        this.background = this.scene.add.rectangle(0, 0, menuWidth, menuHeight, 0x3f3f3f)
            .setOrigin(0, 0)
            .setStrokeStyle(2, 0x6f6f6f);
        this.add(this.background);
        
        // Create option buttons
        this.options.forEach((option, index) => {
            const y = index * 24 + 16;
            
            // Button background
            const buttonBg = this.scene.add.rectangle(4, y - 8, menuWidth - 8, 20, 0x5f5f5f)
                .setOrigin(0, 0)
                .setInteractive()
                .setVisible(true); // Make buttons visible by default
            

            
            // Button text
            const buttonText = this.scene.add.text(8, y, option.text, {
                fontSize: '12px',
                fill: '#ffffff'
            }).setOrigin(0, 0.5);
            
            // Hover effects
            buttonBg.on('pointerover', () => {
                buttonBg.setFillStyle(0x7f7f7f); // Lighter background on hover
                buttonText.setFill('#ffff00');
            });
            
            buttonBg.on('pointerout', () => {
                buttonBg.setFillStyle(0x5f5f5f); // Original background
                buttonText.setFill('#ffffff');
            });
            
            // Click handler
            buttonBg.on('pointerdown', (pointer) => {
                // Stop event propagation to prevent outside click handler
                pointer.event.stopPropagation();
                
                if (option.callback) {
                    option.callback();
                }
                this.hide();
            });
            
            this.add([buttonBg, buttonText]);
            this.optionButtons.push({ bg: buttonBg, text: buttonText });
            

        });
    }
    
    show(x, y) {
        // Get actual menu dimensions
        const menuWidth = this.menuWidth;
        const menuHeight = this.menuHeight;
        
        // Check boundaries and adjust position
        const sceneWidth = this.scene.cameras.main.width;
        const sceneHeight = this.scene.cameras.main.height;
        
        if (x + menuWidth > sceneWidth) {
            x = sceneWidth - menuWidth - 5;
        }
        
        if (y + menuHeight > sceneHeight) {
            y = sceneHeight - menuHeight - 5;
        }
        
        this.setPosition(x, y);
        this.setVisible(true);
        this.isVisible = true;
        
        // Add outside click listener after a brief delay to prevent immediate hiding
        setTimeout(() => {
            if (this.scene && this.scene.input && this.isVisible) {
                this.scene.input.on('pointerdown', this.handleOutsideClick, this);
            }
        }, 100);
    }
    
    hide() {
        this.setVisible(false);
        this.isVisible = false;
        
        // Remove outside click listener safely
        if (this.scene && this.scene.input) {
            this.scene.input.off('pointerdown', this.handleOutsideClick, this);
        }
    }
    
    handleOutsideClick(pointer) {
        // Check if the menu is still visible and valid
        if (!this.isVisible || !this.scene) {
            return;
        }
        
        // Check if click is outside the menu bounds
        const bounds = this.getBounds();
        if (!bounds.contains(pointer.x, pointer.y)) {
            this.hide();
        }
    }
    
    updateOptions(newOptions) {
        // Clear existing options
        this.optionButtons.forEach(button => {
            button.bg.destroy();
            button.text.destroy();
        });
        this.optionButtons = [];
        
        // Remove background
        if (this.background) {
            this.background.destroy();
        }
        
        // Update options and recreate menu
        this.options = newOptions;
        this.createMenu();
    }
    
    destroy() {
        // Clean up event listeners safely
        if (this.scene && this.scene.input) {
            this.scene.input.off('pointerdown', this.handleOutsideClick, this);
        }
        super.destroy();
    }
} 